











import { Vue, Component } from 'vue-property-decorator';
import CamaraEnVivo from '@/pantallas/Camaras/EnVivo/CamaraEnVivo.vue';
import CamaraEnVivoOperaciones from '@/pantallas/Camaras/EnVivo/CamaraEnVivoOperaciones.vue';
import CamaraEventBus from '@/pantallas/Camaras/CamaraEventBus';

@Component({
  components: { CamaraEnVivo, CamaraEnVivoOperaciones },
})
export default class CamaraEnVivoPantalla extends Vue {
  moduleType: string = '';
  isOperation: boolean = false;

  created() {
    var self = this;
    CamaraEventBus.$on('reloadComponentInLives', () => {
      //self.chargePatentsCamera();
      let url = new URL(window.location.href);
      self.changedModule();
    });
  }

  mounted() {
    this.changedModule();
  }

  changedModule() {
    let url = new URL(window.location.href);
    if(url.pathname != '/camaras-envivo'){
      this.isOperation = true;
      this.moduleType = 'En Vivo Cámaras';
    }else{
      this.isOperation = false;
      this.moduleType = 'En vivo';
    }
  }
}
